import { css } from '@/styled-system/css';

// Page wrapper styles for inbox - makes a flex container that fills viewport
export const inboxPageWrapperStyles = css.raw({
  height: '100dvh',
  display: 'flex',
  flexDirection: 'column',
});

// Wrapper styles for AppLayoutContainer - fills remaining space after any banners
export const inboxAppLayoutContainerStyles = css.raw({
  flex: 1,
  overflow: 'hidden',
  display: 'flex',
  flexDirection: 'column',
});

// Main content styles for inbox
export const inboxMainContentStyles = css.raw({
  display: 'flex',
  flexDirection: 'column',
  height: '100%',
  overflow: 'hidden',
  paddingBottom: 0,
});

export const pageContentStyles = css.raw({
  height: '100%',
  width: '100%',
  // oxlint-disable-next-line constellation/no-raw-spacing-values -- `maxWidth: 1280px` is past the end of the numeric sizes scale, which stops at `5000` (200px)
  maxWidth: '1280px',
  display: 'flex',
  flexDirection: 'column',
  alignSelf: 'center',
  paddingBlock: '0',
  paddingInline: '0',
  marginBlock: '0',
  xl: {
    paddingInline: 'default',
  },
});

// Full height container for conversation columns
export const columnWrapperStyles = css.raw({
  background: 'bg.neutral',
  display: 'flex',
  height: '100%',
  borderRadius: '0',
  flex: 1,
  overflowY: 'auto',
  border: '1px solid',
  borderColor: 'border.muted',
  xlDown: {
    borderInline: 'none',
    borderBottom: 'none',
  },
});

// Primary column (conversation list) styles
export const primaryColumnStyles = css.raw({
  display: 'flex',
  flexDirection: 'column',
  alignSelf: 'stretch',
  width: '100%',
  xl: {
    borderRight: '1px solid',
    borderRightColor: 'border.muted',
    maxWidth: '25%',
    // oxlint-disable-next-line constellation/no-raw-spacing-values -- `minWidth: 360px` is past the end of the numeric sizes scale, which stops at `5000` (200px)
    minWidth: '360px',
  },
});

// Secondary column (message list) styles
export const secondaryColumnStyles = css.raw({
  display: 'flex',
  flexDirection: 'column',
  alignSelf: 'stretch',
  position: 'relative', // Must remain relative - Attachments DropZone is positioned relative to column
  width: '100%',
});
